// @flow

import {RideStatus, ServerRideStatus} from "../../../Utils/AppUtils";

export const AciveRideStatuses = [RideStatus.ACCEPTED, RideStatus.BOARDED];
export const ActiveServerRideStatuses = [ServerRideStatus.ACCEPTED, ServerRideStatus.BOARDED];

export const InvalidRideStatuses = [RideStatus.CANCELLED, RideStatus.NO_SHOW];
export const InvalidServerRideStatuses = [ServerRideStatus.CANCELED, ServerRideStatus.NO_SHOW];

export const FinishedRideStatuses = [RideStatus.FINISHED, RideStatus.FEEDBACK];
export const FinishedServerRideStatuses = [ServerRideStatus.FINISHED, ServerRideStatus.FEEDBACK];


export type DriverPhoneData = {
    driver_phone?: string,
}


// WEBPACK FOOTER //
// ./src/Store/Ducks/CurrentRide/utils.js